import React from 'react';

import { RadioGroup } from '@infoods/lifebase-ui';
import { useAsync } from 'react-use';

import classes from './SelectReactivationSubscriptionModal.module.scss';
import { LbBigModal } from '../../../../../shared/components/modals';
import { customerSubscriptionService } from '../../../../services/customerSubscriptionService';
import { SubscriptionCard } from '../../../../components/SubscriptionRow/SubscriptionCard';
import { BillingTypeFlags } from '../../../../../shared/constants/user-info/billingType';

type SelectReactivationSubscriptionModalProps = {
  customerId: number;
  entityBillingType: BillingTypeFlags;
  onClose: () => void;
  onConfirm: (subscriptionId: number) => void;
};

// TODO refactor find better name
const SelectReactivationSubscriptionModal = ({
  customerId,
  entityBillingType,
  onClose,
  onConfirm,
}: SelectReactivationSubscriptionModalProps) => {
  const [selectedSubscriptionId, setSelectedSubscriptionId] = React.useState<
    number | null
  >(null);

  const {
    value: subscriptions = [],
    loading,
    error,
  } = useAsync(
    () => customerSubscriptionService.getExplorePlans(customerId),
    [customerId],
  );

  const description = entityBillingType.SELF_BILLING
    ? 'Upon confirmation, the user account is activated, and access to the mobile app is automatically restored.'
    : `Upon confirmation, the user will receive an email containing a payment link. 
    Once the payment is made, access to the application will be resumed.`;

  const yesBtnText = entityBillingType.SELF_BILLING
    ? 'Confirm'
    : 'Confirm & Send the Payment Link via email';

  const handleConfirm = () => {
    if (selectedSubscriptionId) {
      onConfirm(selectedSubscriptionId);
      onClose();
    }
  };

  return (
    <LbBigModal
      open={!loading && !error}
      title="Send Reactivation"
      description={description}
      buttonOptions={{
        yesText: yesBtnText,
        noText: 'Cancel',
        yesHandler: handleConfirm,
        noHandler: onClose,
        yesDisabled: !selectedSubscriptionId,
      }}
    >
      <RadioGroup value={selectedSubscriptionId} className={classes.subscriptionsBox}>
        {subscriptions.map((subscription) => (
          <SubscriptionCard
            key={subscription.id}
            subscription={subscription}
            onClick={setSelectedSubscriptionId}
          />
        ))}
      </RadioGroup>
    </LbBigModal>
  );
};

export { SelectReactivationSubscriptionModal };
